// @flow
import React, { type Node } from 'react';

import Loading from 'app/common/components/Loader';
import SimpleDate from 'app/dataProviders/SimpleDate';

import useKlasses from '../useKlasses';
import useKlassValid from '../useKlassValid';
import useDateValid from '../useDateValid';
import useRedirect from '../useRedirect';
import KlassSwitcher from '../KlassSwitcher';
import JournalMain from './JournalMain';
import UndefinedDate from '../UndefinedDate';
import ControlsLayout from '../ControlsLayout';


type Props = {
  studentId: string,
  klassId?: string,
  date?: string,
  dateFormat: string,
  showSummary: boolean,
  additionalControls?: Node,
  redirect: ({ +date?: string, +klassId: string }, writeHistory?: boolean) => void,
  createPath: ({ date?: SimpleDate, summary: boolean }) => string,
}

const Journal = ({
  studentId,
  klassId,
  date,
  dateFormat,
  showSummary,
  additionalControls,
  redirect,
  createPath,
}: Props): Node => {
  const [klasses] = useKlasses(studentId);

  const validatedKlass = useKlassValid(klassId, klasses);
  const validatedDate = useDateValid({ date, dateFormat, klass: validatedKlass });
  const { changeKlass } = useRedirect({
    klassId: validatedKlass ? validatedKlass.id : null,
    date: validatedDate,
    redirect,
    dateFormat,
  });

  const validatedKlassKlassId = validatedKlass ? validatedKlass.id : null;

  if (!validatedKlassKlassId || !validatedKlass) { // klassValid because flow
    return (<Loading />);
  }

  if (!validatedDate) {
    return (
      <UndefinedDate>
        {klasses.length > 1
          && <ControlsLayout leftContent={additionalControls}>
            <KlassSwitcher
              klasses={klasses}
              klassId={validatedKlassKlassId}
              onChangeKlass={changeKlass}
            />
          </ControlsLayout>}
      </UndefinedDate>
    );
  }

  return (
    <JournalMain
      studentId={studentId}
      date={validatedDate}
      klass={validatedKlass}
      additionalControls={additionalControls}
      showSummary={showSummary}
      createPath={createPath}
    >
      <KlassSwitcher
        klasses={klasses}
        klassId={validatedKlassKlassId}
        onChangeKlass={changeKlass}
      />
    </JournalMain>
  );
};

export default Journal;
